import styled from "styled-components";
import { NavLink } from "react-router-dom";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const UserHeader = styled.div`
  width: 100%;
  padding: 20px;
  border: 1px solid #e8eaed;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px 0px #eaeaea40;
  border-radius: 10px;
  @media screen and (max-width: 767px) {
    width: 90%;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    padding: 10px;
  }
`;

const UserSubHeader = styled.div`
  padding: 5px 65px;
  width: 88%;
  margin: 0 auto;
  background-color: #f7f7f7;
  border-radius: 10px;
  @media screen and (max-width: 767px) {
    width: 70%;
    padding: 5px 40px;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    width: 75%;
  }
`;

const UserHeaderSpan1 = styled(NavLink)<{ active: boolean }>`
  padding-right: 40px;
  font-size: 14px;
  font-weight: ${({ active }) => (active ? "500" : "400")};
  padding: 15px 20px;
  border-radius: 10px;
  cursor: pointer;
  text-decoration: none;
  color: ${({ active }) => (active ? "#09005B" : "#5E5E5E")};
  background-color: ${({ active }) => (active ? "#fff" : "transparent")};
  border: 1px solid ${({ active }) => (active ? "#e8eaed" : "none")};
  @media screen and (max-width: 767px) {
    padding: 9px 10px;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
  }
`;

const UserManagementHeader = () => {
  const theme = useTheme();
  return (
    <div
      style={{
        width: "74vw",
        paddingLeft: "20px",
        paddingBottom: "40px",
      }}
    >
      <UserHeader>
        <UserSubHeader>
          <TableContainer
            sx={{
              alignContent: "left",
              marginLeft: "-6%",
            }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      borderBottom: "none",
                      width: "15%",
                      [theme.breakpoints.down("sm")]: {
                        width: "20%",
                      },

                      [theme.breakpoints.down("md")]: {
                        width: "24%",
                      },
                      [theme.breakpoints.up("md")]: {
                        width: "24%",
                      },
                    }}
                  >
                    <div>
                      <UserHeaderSpan1
                        to="/dashboard/user-profile"
                        active={
                          window.location.pathname === "/dashboard/user-profile"
                        }
                      >
                        User Profile
                      </UserHeaderSpan1>
                    </div>
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: "none",
                      width: "17%",
                    }}
                  >
                    <UserHeaderSpan1
                      to="/dashboard/permission"
                      active={
                        window.location.pathname === "/dashboard/permission"
                      }
                    >
                      Permission
                    </UserHeaderSpan1>
                    {/* </div> */}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderBottom: "none",
                      width: "68%",
                    }}
                  >
                    {" "}
                    <div>
                      <UserHeaderSpan1
                        to="/dashboard/account-settings"
                        active={
                          window.location.pathname ===
                          "/dashboard/account-settings"
                        }
                      >
                        Account Settings
                      </UserHeaderSpan1>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
        </UserSubHeader>
      </UserHeader>
    </div>
  );
};

export default UserManagementHeader;
